import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-round-settings',
  templateUrl: './round-settings.component.html',
  styleUrls: ['./round-settings.component.css']
})
export class RoundSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
